"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingPublicNodesAccess = void 0;
const nodesAccess_1 = require("../nodes/nodesAccess");
const mediaTypes_1 = require("../nodes/mediaTypes");
const uids_1 = require("../uids");
class SharingPublicNodesAccess extends nodesAccess_1.NodesAccess {
    url;
    token;
    publicShareKey;
    publicRootNodeUid;
    constructor(telemetry, apiService, cache, cryptoCache, cryptoService, sharesService, url, token, publicShareKey, publicRootNodeUid) {
        super(telemetry, apiService, cache, cryptoCache, cryptoService, sharesService);
        this.url = url;
        this.token = token;
        this.publicShareKey = publicShareKey;
        this.publicRootNodeUid = publicRootNodeUid;
        this.token = token;
        this.publicShareKey = publicShareKey;
        this.publicRootNodeUid = publicRootNodeUid;
    }
    async getParentKeys(node) {
        // If we reached the root node of the public link, return the public
        // share key even if user has access to the parent node. We do not
        // support access to nodes outside of the public link context.
        // For other nodes, the client must use the main SDK.
        if (node.uid === this.publicRootNodeUid) {
            return {
                key: this.publicShareKey,
            };
        }
        return super.getParentKeys(node);
    }
    async getNodeUrl(nodeUid) {
        const node = await this.getNode(nodeUid);
        if ((0, mediaTypes_1.isProtonDocument)(node.mediaType) || (0, mediaTypes_1.isProtonSheet)(node.mediaType)) {
            const { nodeId } = (0, uids_1.splitNodeUid)(nodeUid);
            const type = (0, mediaTypes_1.isProtonDocument)(node.mediaType) ? 'doc' : 'sheet';
            return `https://docs.proton.me/doc?type=${type}&mode=open-url&token=${this.token}&linkId=${nodeId}`;
        }
        // Public link doesn't support specific node URLs.
        return this.url;
    }
}
exports.SharingPublicNodesAccess = SharingPublicNodesAccess;
//# sourceMappingURL=nodes.js.map